import { GzHealthDashboardEndpointEncryptionWebComponent } from './component/GzHealthDashboardEndpointEncryptionWebComponent';
export { GzHealthDashboardEndpointEncryptionWebComponent };
